/* tslint:disable */
/* eslint-disable */
/**
 * AIS Database Loader API
 * API for retrieving AIS database and filestore date ranges.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyRangeGet200ResponseFilestore
 */
export interface DailyRangeGet200ResponseFilestore {
    /**
     * The earliest date available in the filestore.
     * @type {Date}
     * @memberof DailyRangeGet200ResponseFilestore
     */
    begin: Date;
    /**
     * The latest date available in the filestore.
     * @type {Date}
     * @memberof DailyRangeGet200ResponseFilestore
     */
    end: Date;
}

/**
 * Check if a given object implements the DailyRangeGet200ResponseFilestore interface.
 */
export function instanceOfDailyRangeGet200ResponseFilestore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "begin" in value;
    isInstance = isInstance && "end" in value;

    return isInstance;
}

export function DailyRangeGet200ResponseFilestoreFromJSON(json: any): DailyRangeGet200ResponseFilestore {
    return DailyRangeGet200ResponseFilestoreFromJSONTyped(json, false);
}

export function DailyRangeGet200ResponseFilestoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRangeGet200ResponseFilestore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'begin': (new Date(json['begin'])),
        'end': (new Date(json['end'])),
    };
}

export function DailyRangeGet200ResponseFilestoreToJSON(value?: DailyRangeGet200ResponseFilestore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'begin': (value.begin.toISOString()),
        'end': (value.end.toISOString()),
    };
}

